import antdEl from 'antd/lib/locale-provider/el_GR';
import appLocaleData from 'react-intl/locale-data/el';
// import elMessages from '../locales/el_GR.json';
// import { getKeys, getValues } from '../conversion';
// getValues(enMessages);

const ElLang = {
  messages: {
    // ...elMessages,
  },
  antd: antdEl,
  locale: 'el-GR',
  data: appLocaleData,
};
export default ElLang;
